import React, { createContext, useEffect, useState } from "react";
import App from "./App";
import toast, { Toaster } from "react-hot-toast";
import copy from "copy-to-clipboard";
import {
  createWeb3Modal,
  defaultConfig,
  useDisconnect,
  useSwitchNetwork,
  useWeb3ModalAccount,
  useWeb3ModalProvider,
} from "@web3modal/ethers5/react";
import { useWeb3Modal } from "@web3modal/ethers5/react";
import { ethers } from "ethers";
import settings from "./settings.json";
export const ProjectContext = createContext();
const projectId = "ef2338994e0ff071a3a8a24abfe03b88";
// const projectId = process.env.REACT_APP_PROJECT_ID;
//const mainnet = [
 // {
   // chainId: 97,
   // name: "BSc Testnet",
   // currency: "BNB",
   // explorerUrl: "https://testnet.bscscan.com",
   // rpcUrl: "https://data-seed-prebsc-1-s1.binance.org:8545",
 // },
//];
// const mainnet = [{
//   chainId: 11155111,
//   name: "Sepolia",
//   currency: "ETH",
//   explorerUrl: "https://sepolia.etherscan.io",
//   rpcUrl: "https://sepolia.infura.io",
// }];
const mainnet = [{
     chainId: 56,
     name: "Binance Smart Chain",
     currency: "BNB",
     explorerUrl: "https://bscscan.com",
     rpcUrl: "https://bsc-dataseed.binance.org",
 }];

const metadata = {
  name: "KryptoGram",
  description: "KryptoGram",
  url: process.env.REACT_APP_LINK, // origin must match your domain & subdomain
  icons: ["https://avatars.mywebsite.com/"],
};

createWeb3Modal({
  ethersConfig: defaultConfig({
    metadata,
    defaultChainId: mainnet[0].chainId,
    enableEIP6963: true,
    enableInjected: true,
    enableCoinbase: true,
    rpcUrl: "...", // used for the Coinbase SDK
  }),
  chains: mainnet,
  projectId,
  enableAnalytics: true, // Optional - defaults to your Cloud configuration
});

function Projectcontext() {
  var { address, chainId, isConnected } = useWeb3ModalAccount();
  // address = "0xfd6f14b275ab9ffc58fbd4c74b11dfab89caa8d6";
  const { disconnect } = useDisconnect();
  const { switchNetwork } = useSwitchNetwork();
  // const { error } = useWeb3ModalError()

  const [maticbalance, setmaticBalance] = useState(0);
  const [balance, setBalance] = useState(0);
  const [esigner, setesigner] = useState(null);
  const [dbuser, setdbuser] = useState(null);
  const [account, setaccount] = useState(address);
  const [dbuserload, setdbuserload] = useState(false);
  const [stakcontract, setstakcontract] = useState(null);
  const [stakcontract_selite, setstakcontract_selite] = useState(null);
  const [reloadData, setreloadData] = useState(false);
  const [user_stats, setuser_stats] = useState(null);
  const [stats, setstats] = useState(null);
  const [elite, setelite] = useState({ url: "", nfts: [] });
  const [superelite, setsuperelite] = useState({ url: "", nfts: [] });

  const { open } = useWeb3Modal();
  const { walletProvider } = useWeb3ModalProvider();

  const [isClassToggled, setIsClassToggled] = useState(false);
  const [showmenu, setshowmenu] = useState(false);

  // const settings = []
  const formatAddress = (address) => {
    if (address) {
      return address.substr(0, 6) + "..." + address.substr(-6, 6);
    }
  };
  function reload() {
    setreloadData(!reloadData);
  }
  const connectInjected = async () => {
    try {
      await open();
    } catch (ex) {
      console.log(ex);
    }
  };
  const toastError = (data) => {
    toast.error(data);
  };
  const toastSuccess = (data) => {
    toast.success(data);
  };
  const toastInfo = (data) => {
    toast(data, {
      // Custom Icon
      icon: "❕",
      // Aria
      ariaProps: {
        role: "status",
        "aria-live": "polite",
      },
    });
  };

  const copyaddress = (address) => {
    copy(address);
    toastSuccess("Copied");
  };

  async function disconnectNow() {
    try {
      // deactivate();
      disconnect();
      localStorage.setItem("isconnected", false);
      setdbuser(null);
      setdbuserload(false);
      setBalance(0);
    } catch (ex) {
      console.log(ex);
    }
  }

  const connectMetamask = async () => {
    try {
      open();

      localStorage.setItem("isconnected", true);
    } catch (error) {
      alert(error);
    }
  };

  function formatDateTime(timestamp) {
    if (timestamp === 0) {
      return "-";
    }
    const date = new Date(timestamp * 1000); // Convert Unix timestamp to milliseconds

    // Get the date components
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-based
    const year = date.getFullYear();

    // Get the time components
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const seconds = date.getSeconds().toString().padStart(2, "0");

    // Construct the formatted date-time string
    const formattedDateTime = `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;

    return formattedDateTime;
  }
  const getSigner = async () => {
    if (!isConnected) return;

    const ethersProvider = new ethers.providers.Web3Provider(walletProvider);
    const signer = await ethersProvider.getSigner();
    setesigner(signer);
    const balance = await ethersProvider.getBalance(account);
    setmaticBalance(Number(ethers.utils.formatUnits(balance, 18)).toFixed(2));
  };
  function addTimeToDate(date, hours, minutes) {
    let newDate = new Date(date);
    newDate.setHours(newDate.getHours() + hours);
    newDate.setMinutes(newDate.getMinutes() + minutes);
    return newDate;
  }
  function countDate(totalHours) {
    let hours = Math.floor(totalHours);
    let minutes = Math.round((totalHours - hours) * 60);

    return { hours, minutes };
    // console.log(`Hours: ${hours}, Minutes: ${minutes}`); // Outputs "Hours: 2, Minutes: 24"
  }

  const getsmcs = async () => {
    if (!isConnected || !settings.token || esigner === null) return;
    // let contract = new ethers.Contract(
    //   settings.token,
    //   settings.tokenAbi,
    //   esigner
    // );
    let maincontractwrite = new ethers.Contract(
      settings.eliteAddress,
      settings.eliteABI,
      esigner
    );
    setstakcontract(maincontractwrite);
    let superElite = new ethers.Contract(
      settings.sEliteAddress,
      settings.sEliteABI,
      esigner
    );
    setstakcontract_selite(superElite);
    if (account) {
      const elite = await maincontractwrite.getOwnedNFTs(account);
      // const url = await maincontractwrite.getOwnedNFTs(account);
      const url =
        "https://ipfs.io/ipfs/QmXzTfiQ1X5c986rBkXhmHUFLfdArfTWcgDpETS9UGbSx3";
      const numberArray = elite.map((item) => parseInt(item._hex, 16));
      console.log("elite", numberArray);
      setelite({ url: url, nfts: numberArray });

      const selite = await superElite.getOwnedNFTs(account);
      // const surl = await superElite.getOwnedNFTs(account);
      const surl =
        "https://ipfs.io/ipfs/bafybeihu2vexrl6qhz4b3hmqxompzuhvkb4lzug2jtpr6jbbbp3v2s6kdm";
      const snumberArray = selite.map((item) => parseInt(item._hex, 16));
      console.log("selite", snumberArray);
      setsuperelite({ url: surl, nfts: snumberArray });
    }
  };

  useEffect(() => {
    getsmcs();
    // }, [account, address,library, settings]);
  }, [isConnected, account, walletProvider, settings, esigner, reloadData]);
  useEffect(() => {
    getSigner();
  }, [isConnected, account, walletProvider]);
  function checkNegative(value) {
    if (value < 0) {
      return 0;
    } else {
      return value;
    }
  }
  useEffect(() => {
    setaccount(address);
    // if (address) {
    //   localStorage.setItem("isconnected", true);
    // }
  }, [address]);

  return (
    <>
      <Toaster
        position="top-left"
        toastOptions={{
          // Define default options
          className: "",
          duration: 3000,
          style: {
            background: "#ffa518",
            color: "#fff",
          },
          success: {
            duration: 3000,
            theme: {
              primary: "green",
              secondary: "black",
            },
          },
        }}
      />
      <ProjectContext.Provider
        value={{
          settings: settings,
          library: ethers,
          balance,
          maticbalance,
          dbuser,
          stakcontract_selite,
          esigner,
          account: account ? account.toLowerCase() : account,
          connectInjected,
          disconnectNow,
          checkNegative,
          connectMetamask,
          formatAddress,
          toastError,
          toastSuccess,
          toastInfo,
          getsmcs,
          ethers,
          copyaddress,
          stakcontract,
          formatDateTime,
          setaccount,
          reload,
          reloadData,
          switchNetwork,
          isClassToggled,
          setIsClassToggled,
          showmenu,
          setshowmenu,
          stats,
          user_stats,
          superelite,
          elite,
        }}
      >
        <App />
      </ProjectContext.Provider>
    </>
  );
}

export default Projectcontext;
